function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.292 15.571V9.995a7.292 7.292 0 00-4.754-6.827 2.572 2.572 0 00-5.08 0 7.286 7.286 0 00-4.75 6.827v5.576a2.574 2.574 0 01-2.573 2.574h19.73a2.574 2.574 0 01-2.573-2.574zM13.574 18.145a2.575 2.575 0 01-5.148 0"
}));

function SvgNotifications(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22
  }, props), _ref);
}

export default SvgNotifications;